import { Injectable } from '@angular/core';

@Injectable()
export class DateUtils {
	getWeekNumber(d: Date) {
		if (typeof d === 'string') {
			d = new Date(d);
		}
		// Copy date so don't modify original
		d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
		// Set to nearest Thursday: current date + 4 - current day number
		// Make Sunday's day number 7
		d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
		// Get first day of year
		const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
		// Calculate full weeks to nearest Thursday
		const weekNo = Math.ceil(
			((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
		);
		// Return week number
		return weekNo;
	}

	getMonday(d) {
		d = new Date(d);
		const day = d.getDay();
		const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
		return new Date(d.setDate(diff));
	}

	addDays(date: Date, days: number) {
		const result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
	}

	timeConvert(minutes: number) {
		let h: any = Math.floor(minutes / 60);
		let m: any = Math.round(minutes % 60);
		h = h < 10 ? '0' + h : h;
		m = m < 10 ? '0' + m : m;
		if (m === 60) {
			h++;
			m = 0;
		}
		return `${h}h${m}`;
	}

	convertFromDateToMinuteString(date: Date) {
		const minutesNumber = this.convertFromDateToMinutes(date);
		return this.timeConvert(minutesNumber);
	}

	convertStringHoursToNumber(hours: string): number {
		const hoursSplitted = hours.split(':');
		const result: number =
			parseInt(hoursSplitted[0], 10) * 60 + parseInt(hoursSplitted[1], 10);
		return result;
	}

	convertStringHoursMinToNumber(hours: string): number {
		// on retire le m
		hours = hours.slice(0, -1);
		const hoursSplitted = hours.split('h');
		const result =
			parseInt(hoursSplitted[0], 10) * 60 + parseInt(hoursSplitted[1], 10);
		return result;
	}

	getFullDateFromDateAndMinutes(date: Date, min: number): Date {
		return new Date(new Date(date).getTime() + min * 60 * 1000);
	}

	getDateOfISOWeek(w: number, y: number) {
		const simple = new Date(y, 0, 1 + (w - 1) * 7);
		const dow = simple.getDay();
		const ISOweekStart = simple;
		if (dow <= 4) {
			ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
		} else {
			ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
		}
		return ISOweekStart;
	}

	/**
	 * Check si les dates sont les mêmes selon l'année, le mois et le jour
	 * @param date1
	 * @param date2
	 * @returns
	 */
	isSameDate(date1: Date, date2: Date): boolean {
		return (
			date1.getFullYear() === date2.getFullYear() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getDay() === date2.getDay()
		);
	}

	/**
	 *
	 * @param date Date
	 * @returns date au format UTC avec l'annee, le mois et la date
	 */
	convertDateToUTCDate(date: Date) {
		return new Date(
			Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
		);
	}

	/**
	 *
	 * @param start Date de début
	 * @param end Date de fin
	 * @returns tableau de date entre le début et la fin
	 */
	getDatesBetweenStartAndEndDates(start: Date, end: Date): Date[] {
		start = this.convertDateToUTCDate(start);
		end = this.convertDateToUTCDate(end);
		let arr = [];
		for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
			arr.push(new Date(dt));
		}
		return arr;
	}

	/**
	 * Renvoie un list de {week:number,year:number} en fonction d'un date de début et de fin
	 * @param start Date de début
	 * @param end Date de fin
	 * @returns
	 */
	getWeekAndYearListBetweenStartAndEnd(
		start: Date,
		end: Date
	): { week: number; year: number }[] {
		let listDate = this.getDatesBetweenStartAndEndDates(start, end);
		let listYearAndWeek: { week: number; year: number }[] = [];
		for (let date of listDate) {
			if (
				!listYearAndWeek.find(
					(yaw) =>
						yaw.week === this.getWeekNumber(date) &&
						yaw.year === date.getFullYear()
				)
			) {
				listYearAndWeek.push({
					week: this.getWeekNumber(date),
					year: date.getFullYear()
				});
			}
		}
		return listYearAndWeek;
	}

	convertFromDateToMinutes(date: Date) {
		return date.getHours() * 60 + date.getMinutes();
	}

	// convert date to ISO format (yyyy-mm-dd)
	convertFromDateToDateWithDash(date: Date): string {
		const dateFinal = new Date(date);
		dateFinal.setDate(dateFinal.getDate() + 1); // + 1 car ISO crée un décalage de -1 journée
		return dateFinal.toISOString().slice(0, 10).replaceAll('/', '-');
	}
}
